module.exports = __webpack_public_path__ + "assets/img/title.6ee6bad7.png";